// extracted by mini-css-extract-plugin
export var deliveryRow = "_n9-a";
export var fixedHeight = "_n9-4";
export var freightLogo = "_n9-9";
export var fullWidth = "_n9-3";
export var priceColumn = "_n9-5";
export var radioSelected = "_n9-7";
export var radioUnselected = "_n9-6";
export var selectedOption = "_n9-2";
export var selectedOptionContainer = "_n9-1";
export var selection = "_n9-0";
export var tallSkeletonText = "_n9-8";